<template>
    <TrimInfoModal
            :modalTitle="'Edit trim info'"
            :btnSubmitTitle="'Save info'"
            :sendStatus="dataSendStatus"
            :errors="errors"
            :isCreateNew="false"
            :isDuplicate="false"
            :isEdit="true"
            :trimId="trim.id"
            :trimNamePreset="trim.trimName"
            :descriptionPreset="trim.description"
            :isSmallTrimPreset="trim.isSmallTrim"
            @formSubmit="saveTrimInfo"
    ></TrimInfoModal>
</template>

<script>
    import { mapActions } from 'vuex';
    import TrimInfoModal from "./TrimInfoModal";

    export default {
        name: "EditTrimInfoModal",

        components: {
            TrimInfoModal
        },

        emits: [
            'save',
        ],

        props: [
            'trim',
        ],

        data() {
            return {
                dataSendStatus: false,
                errors: null,
            }
        },

        methods: {
            ...mapActions('trims', [
                'updateTrimInfo',
            ]),

            async saveTrimInfo(dataToUpdate) {
                this.errors = null;
                this.dataSendStatus = true;

                let trimNewData = await this.updateTrimInfo(dataToUpdate)
                    .catch((err) => {
                        this.errors = err;
                    })
                    .finally(() => {
                        this.dataSendStatus = false;
                    });

                if (this.errors) return;

                this.$emit('save', trimNewData);

                this.closeModal();
            },

            closeModal() {
                this.$emit('closeModal');
            },

        },

    }
</script>

<style lang="scss">

</style>